import { Card, Space, Tag, Typography, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import Cupoints from "../../Components/Cupoints";
import VideoCard from "../../Components/VideoCard";

const { Text } = Typography;

const ModuleCard = ({ item, onAddToCourse, onView, isOwnModule = false }) => {
    const moduleData = {
        ...item,
        id: item.id,
        name: item.title,
        videos: item.videosList || [],
        price: item.price
    };

    return (
        <Card
            key={item.id}
            size="small"
            className="module-card mb-10"
            title={
                <>
                    <div className="flex space-between mb-10">
                        <Space direction="vertical" size={0}>
                            <Text strong={true} ellipsis={{ tooltip: true }} style={{ maxWidth: 300 }}>
                                {item.title}
                            </Text>
                            {!isOwnModule && (
                                <Text type="secondary">
                                    By {item.authorId ? (
                                        <Link target="_blank" to={`/creators/${item.authorId}`}>
                                            {item.authorName}
                                        </Link>
                                    ) : (
                                        item.authorName
                                    )}
                                </Text>
                            )}
                        </Space>
                        <div className={`module-card-actions ml-auto w-100${isOwnModule ? " module-card-actions--own" : ""}`}>
                            <Space direction="horizontal" size={"small"} align="start">

                                {onView && (
                                    <Button size="small" onClick={() => onView?.(item)}>
                                        View
                                    </Button>
                                )}
                                <Button
                                    size="small"
                                    type="primary"
                                    className="purple-btn"
                                    onClick={() => onAddToCourse?.(item)}
                                >
                                    Add to Course <RightOutlined />
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <Space wrap size={4}>
                        {item.categoryId ? <Tag color="geekblue">{item.category}</Tag> : null}
                        <Tag>{item.videos} videos</Tag>
                        <Tag color="orange">
                            <Cupoints
                                points={item.price}
                                secondaryWithinBrackets={false}
                                hideDollarAmount={true}
                            />
                        </Tag>
                    </Space>
                </>
            }>

            <Space direction="vertical" size={6} style={{ width: "100%" }}>
                <div className="module-card-videos">
                    <div className="module-card-videos-grid">
                        {moduleData.videos.slice(0, 4).map((video, index) => (
                            <div key={video.embedId || video.id} className="module-card-video-card module-card-video-card--bordered">
                                <VideoCard
                                    index={index}
                                    collectionId={null}
                                    module={moduleData}
                                    moduleId={moduleData.id}
                                    mode="preview"
                                    moduleName={moduleData.name}
                                    moduleAccess={{}}
                                    moduleIndex={index}
                                    video={video}
                                    price={moduleData.price}
                                />
                            </div>
                        ))}
                        {moduleData.videos.length > 4 && (
                            <Card
                                size="small"
                                className="module-card-video-card more"
                                bodyStyle={{ padding: "6px 8px" }}
                            >
                                <Text type="secondary">+{moduleData.videos.length - 4} more</Text>
                            </Card>
                        )}
                    </div>
                </div>
            </Space>
        </Card>
    );
};

export default ModuleCard;
